import { render, staticRenderFns } from "./ValoresEnEspera.vue?vue&type=template&id=e82ffb82&scoped=true&"
import script from "./ValoresEnEspera.vue?vue&type=script&lang=js&"
export * from "./ValoresEnEspera.vue?vue&type=script&lang=js&"
import style0 from "./ValoresEnEspera.vue?vue&type=style&index=0&id=e82ffb82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82ffb82",
  null
  
)

export default component.exports